import { BASE_S3_IMAGE_URL } from 'data/configs';
import { resolvePath } from 'utils';

export const buildImgUrl = (suffix: string): string => {
    return resolvePath(BASE_S3_IMAGE_URL, suffix);
};
